import ContentPreloader from '@components/Preloader/ContentPreloader'
import {LANDING} from '@constants/internal-route.constant'
import {ComponentType, createElement, lazy, ReactNode} from 'react'
import {Navigate} from 'react-router-dom'
import {useComplianceAccess} from './useComplianceAccess'

/** The review's route guard: anyone the server would refuse lands on the landing page instead. */
export const RequireCompliance = ({children}: {children: ReactNode}) => {
  const {allowed, checking} = useComplianceAccess()
  if (checking) return <ContentPreloader />
  return allowed ? <>{children}</> : <Navigate to={LANDING} replace />
}

/** {@code guard()} for the review: a lazy page behind RequireCompliance. Kept JSX-free for route files. */
export const complianceGuard = (importer: () => Promise<{default: ComponentType<any>}>) => {
  const Comp = lazy(importer)
  return () => createElement(RequireCompliance, {children: createElement(Comp)})
}
